<div class="overlay" *ngIf="overlay">
  <div class="center">
    <mat-spinner mode="indeterminate" color="color"></mat-spinner>
  </div>
</div>